
    export default {
        props: {
            includes: Array,
            release_date: Number,
            tags: Object
        },
        data() {
            return {
                features: [
                    {
                        img: `//df4emreqpcien.cloudfront.net/images/all-access/coursedetailframe1.png?width=250&format=webp`,
                        title: `Multi-Angle HD Video Lessons`,
                        description: `Clearly see what the educator is demonstrating!`
                    },
                    {
                        img: `//df4emreqpcien.cloudfront.net/images/all-access/coursedetailframe2.png?width=250&format=webp`,
                        title: `Video Tab Sync & Fretboard View`,
                        description: `Easily follow along for quickest progress! Clearly see finger placement on the fretboard!`
                    },
                    {
                        img: `//df4emreqpcien.cloudfront.net/images/all-access/coursedetailframe3.png?width=250&format=webp`,
                        title: `Slow Motion & Looping`,
                        description: `Learn and Practice at your ideal speed! Choose any section of the lesson to focus on!`
                    }
                ],
                searchUrl: ``,
                releaseDate: ``,
            }
        },
        created() {
            if(process.client)
                this.searchUrl = window.location.origin + `/search/?q=`;
            const date = new Date(this.release_date * 1000);
            this.releaseDate = date.toLocaleDateString('en-US', { timeZone: 'America/New_York'}); // specify time zone for consistency
        }
    }
